module.exports = __webpack_public_path__ + "static/media/logo.babe0a08.svg";